// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subfolders[data-v-1cbb078f]{max-height:400px;overflow-y:auto}.subfolders-list tbody tr:first-child td[data-v-1cbb078f]{border-top:none}", ""]);
// Exports
module.exports = exports;
